import { render, staticRenderFns } from "./ReviewPreview.vue?vue&type=template&id=1df9bfbc&scoped=true&"
import script from "./ReviewPreview.vue?vue&type=script&lang=ts&"
export * from "./ReviewPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewPreview.vue?vue&type=style&index=0&id=1df9bfbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df9bfbc",
  null
  
)

export default component.exports